var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6.81818,
    fill: "#3E3E3E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71914_12521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3414 19.821L20.2561 15.571C20.7164 15.3721 20.7164 14.7244 20.2561 14.5255L10.3414 10.2755C9.96635 10.1107 9.55158 10.3892 9.55158 10.7926L9.5459 13.4119C9.5459 13.696 9.75613 13.9403 10.0402 13.9744L18.0686 15.0482L10.0402 16.1164C9.75613 16.1562 9.5459 16.4005 9.5459 16.6846L9.55158 19.3039C9.55158 19.7073 9.96635 19.9857 10.3414 19.821V19.821Z",
    fill: "#E5E5E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71914_12521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.6364,
    height: 13.6364,
    fill: "white",
    transform: "translate(8.18164 8.18188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendChatIcon);
export default __webpack_public_path__ + "static/media/SendChatIcon.1910b91ba0d8fb04a9936dcef00246fe.svg";
export { ForwardRef as ReactComponent };